module.exports = __webpack_public_path__ + "media/images/faces/male/18-dd8e89b641f965cd79ea83755329be2a.jpg";